interface AutoAcceptInviteParams {
  inviteToken?: string | null;
  inviteValid?: boolean | null;
  inviteStatus?: string | null;
  workspaceId?: string | null;
  invitedEmail?: string | null;
  currentEmail?: string | null;
  isAcceptingInvite?: boolean;
  userChoseCreate?: boolean;
  hasInviteStatusError?: boolean;
}

const normalizeEmail = (email?: string | null) =>
  (email || "").trim().toLowerCase();

export const resolveCurrentInviteEmail = (
  userEmail?: string | null,
  profileEmail?: string | null,
) => normalizeEmail(userEmail) || normalizeEmail(profileEmail);

export const shouldAutoAcceptInviteOnOnboarding = ({
  inviteToken,
  inviteValid,
  inviteStatus,
  invitedEmail,
  currentEmail,
  isAcceptingInvite,
  userChoseCreate,
}: AutoAcceptInviteParams): boolean => {
  if (!inviteToken?.trim() || !inviteValid || isAcceptingInvite || userChoseCreate) {
    return false;
  }

  if ((inviteStatus || "").trim().toUpperCase() === "ACCEPTED") {
    return false;
  }

  const normalizedInvitedEmail = normalizeEmail(invitedEmail);
  const normalizedCurrentEmail = normalizeEmail(currentEmail);

  if (!normalizedInvitedEmail || !normalizedCurrentEmail) {
    return false;
  }

  return normalizedInvitedEmail === normalizedCurrentEmail;
};

export const shouldProcessInviteTokenOnOnboarding = ({
  inviteToken,
  inviteValid,
  inviteStatus,
  invitedEmail,
  currentEmail,
  userChoseCreate,
  hasInviteStatusError,
}: AutoAcceptInviteParams): boolean => {
  if (!inviteToken?.trim() || !inviteValid || userChoseCreate || hasInviteStatusError) {
    return false;
  }

  const normalizedStatus = (inviteStatus || "").trim().toUpperCase();
  if (normalizedStatus && normalizedStatus !== "PENDING" && normalizedStatus !== "ACCEPTED") {
    return false;
  }

  const normalizedInvitedEmail = normalizeEmail(invitedEmail);
  const normalizedCurrentEmail = normalizeEmail(currentEmail);
  if (!normalizedInvitedEmail || !normalizedCurrentEmail) {
    return false;
  }

  return normalizedInvitedEmail === normalizedCurrentEmail;
};

export const shouldEnterAcceptedInviteWorkspaceOnOnboarding = ({
  inviteToken,
  inviteValid,
  inviteStatus,
  workspaceId,
  invitedEmail,
  currentEmail,
  userChoseCreate,
}: AutoAcceptInviteParams): boolean => {
  if (!inviteToken?.trim() || !inviteValid || userChoseCreate) {
    return false;
  }

  if ((inviteStatus || "").trim().toUpperCase() !== "ACCEPTED") {
    return false;
  }

  if (!workspaceId?.trim()) {
    return false;
  }

  const normalizedInvitedEmail = normalizeEmail(invitedEmail);
  const normalizedCurrentEmail = normalizeEmail(currentEmail);

  if (!normalizedInvitedEmail || !normalizedCurrentEmail) {
    return false;
  }

  return normalizedInvitedEmail === normalizedCurrentEmail;
};
